var _style, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgItemsEmpty(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 640 512",
    style: {
      enableBackground: "new 0 0 640 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FF9352;}\n\t.st1{fill:#FFB14F;}\n\t.st2{fill:#FF755C;}\n\t.st3{fill:#FF4185;}\n\t.st4{fill:#FFCE42;}\n")), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "282.1,24.3 282.1,193.6 461.1,287.8 640,313.7 640,120.1 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "282.1,0 177.1,35.2 535,155.4 640,120.1 "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "124,340.1 357.9,432.7 531.2,365.5 282.1,272.9 "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "282.1,297.2 297.3,245.4 282.1,193.6 0,288.3 82.1,364.3 "
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "485.7,365.5 640,313.7 282.1,193.6 282.1,297.2 "
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "0,288.3 0,391.9 357.9,512 388.2,460.2 357.9,408.4 "
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "357.9,408.4 357.9,512 640,417.3 640,313.7 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItemsEmpty);
export default __webpack_public_path__ + "static/media/items-empty.677e6ca956d8907c6eda3b85f3fc8b72.svg";
export { ForwardRef as ReactComponent };